import auth from './auth';
import connection from './connection';
import messageQueue from './messageQueue';
import requests from './requests';

export default {
	// namespaced: true,
	modules: {
		auth, connection, messageQueue, requests
	}
}
